import './index.css';
// Imported after index.css on purpose: these rules must win the cascade.
import './styles/print.css';
import './styles/mobile.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import resumeData from '../resume.json';
import App from './App.tsx';
import type { Resume } from './types/cv';
import type { Locale } from './i18n/config';

const language = ((resumeData as Resume).meta?.language ||
  import.meta.env.VITE_LANGUAGE ||
  'en') as Locale;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App resume={resumeData as Resume} language={language} />
  </StrictMode>
);
